import React, {Component} from 'react';
import {Button} from 'rmwc/Button';
import {
  Card,
  CardPrimaryAction,
  CardMedia,
  CardAction,
  CardActions,
  CardActionButtons,
  CardActionIcons
} from 'rmwc/Card';
import {GridTile,GridTilePrimaryContent} from 'rmwc/GridList';
import { Chip, ChipText, ChipIcon, ChipSet } from 'rmwc/Chip';
import {Icon} from 'rmwc/Icon';

import { Typography } from 'rmwc/Typography';
import { TextField, TextFieldIcon, TextFieldHelperText } from 'rmwc/TextField';


export default class EnergyItem extends Component {
  constructor(props) {
    super(props);
    this.onClickClose = this.onClickClose.bind(this);
  }

  onClickClose() {
    let index = parseInt(this.props.index);
    this.props.removeItem(index);
  }

  render() {
      let energyClass = this.props.item.done ? "done" : "undone";
    return(
<GridTile tileAspect='4x3'>
      <Card>

        <CardMedia sixteenByNine style={{backgroundImage: 'url(https://material-components-web.appspot.com/images/1-1.jpg)'}}/>
        <div style={{position: 'absolute', top: '14%',left: '50%', transform: 'translate(-50%, -50%)', color: 'white'}}><Typography use="headline"><Icon strategy="component" use="settings_input_antenna" />{(this.props.item.power*this.props.item.hours/1000).toFixed(2)}kWh</Typography></div>
        <div style={{padding: '0 1rem 1rem 1rem'}}>
          <Typography
      use="subheading1"
      tag="h3"
      theme="text-secondary-on-background"
      style={{marginTop: '0.5rem', textAlign: 'left'}}
    >
    </Typography>
     <Typography use="title" tag="h2">{this.props.item.value}</Typography>
     <Typography
       use="subheading1"
       tag="h3"
       theme="text-secondary-on-background"
       style={{marginTop: '-1rem'}}
     >
     </Typography>
     <Typography use="body1" tag="div" theme="text-secondary-on-background"></Typography>
   </div>
   <ChipSet>
     <Chip>
       <ChipIcon leading use="flash_on" />
       <ChipText> {this.props.item.voltage}V</ChipText>
     </Chip>
   </ChipSet>
   <ChipSet>
     <Chip>
       <ChipIcon leading use="power" />
       <ChipText> {this.props.item.power}W</ChipText>
     </Chip>
   </ChipSet>
   <ChipSet>
     <Chip>
       <ChipIcon leading use="access_time" />
       <ChipText> {this.props.item.hours}h</ChipText>
     </Chip>
   </ChipSet>
   <CardActions>
    <CardActionIcons>
      <CardAction icon use="delete" onClick={this.onClickClose}/>
    </CardActionIcons>
    </CardActions>
        </Card>
</GridTile>

    )
  }
}



// WEBPACK FOOTER //
// ./src/components/EnergyItem/EnergyItem.js